module.exports = __webpack_public_path__ + "static/media/higher-education-landscape.ccbde5b1.jpg";